// Bridges SideNav's chat buttons to a dashboard's own drawer state, without each dashboard
// having to hand-wire it. Mix into any component that already defines `isAIDrawerOpen`,
// `isLoanLaunchDrawerOpen`, and `loanLaunchUnread` (LoanOfficerDashboard.vue,
// ProcessorDashboard.vue, LoanOfficerAssistantDashboard.vue all do — same field names,
// independently, one per role's dashboard).
//
// Root cause this fixes: the rail's buttons used to target CommandCenter.vue, but the route
// that's actually live at "/" is DashboardShell.vue, which swaps in one of the three dashboards
// above depending on role. CommandCenter.vue isn't mounted there, so nothing happened. This
// mixin lives on the three real hosts instead — whichever is mounted responds.
//
// If a future dashboard reuses this drawer pattern, just add `mixins: [sidebarChatBridge]` to
// it too — no other wiring needed.

import bus from "@/helpers/appBus.js"
import {
  CHAT_OPEN_EVENT,
  CHAT_KIND_SWIFT,
  CHAT_KIND_LOANLAUNCH,
  consumePendingChat,
  publishChatUnread,
  registerChatHost,
  unregisterChatHost
} from "@/helpers/chatLauncher.js"

export default {
  watch: {
    // Whenever the host's own unread count changes (its existing fetchLoanLaunchUnread already
    // sets this), mirror it to the rail's badge.
    loanLaunchUnread(n) {
      publishChatUnread(n)
    }
  },
  mounted() {
    // While this dashboard is up it answers the rail's buttons with its own dock, so the
    // app-wide SidebarChatHost stands down.
    registerChatHost()
    bus.on(CHAT_OPEN_EVENT, this.__onSidebarChatOpen)

    // The rail may have navigated here to fulfill a click that happened on another page —
    // that intent is waiting for us.
    const pending = consumePendingChat()
    if (pending) this.__onSidebarChatOpen(pending)

    // Push whatever unread count the host already has, in case it was fetched before this
    // mixin's watcher attached (host's own mounted() runs after mixin mounted() hooks).
    if (typeof this.loanLaunchUnread === "number") publishChatUnread(this.loanLaunchUnread)
  },
  beforeUnmount() {
    unregisterChatHost()
    bus.off(CHAT_OPEN_EVENT, this.__onSidebarChatOpen)
  },
  methods: {
    __onSidebarChatOpen(kind) {
      if (kind === CHAT_KIND_SWIFT) {
        this.isLoanLaunchDrawerOpen = false
        this.isAIDrawerOpen = true
      } else if (kind === CHAT_KIND_LOANLAUNCH) {
        this.isAIDrawerOpen = false
        this.isLoanLaunchDrawerOpen = true
      }
    }
  }
}
